const _ = require('underscore');
const React = require('react');
const createReactClass = require("create-react-class");

const EditIntegrationForm = require('./EditIntegrationForm.jsx');
const Modal = require('../../deploynaut/js/Modal.jsx');

const Integrations = createReactClass({
	getInitialState: function() {
		return {
			SecurityID: this.props.model.InitialSecurityID,
			modal: null,
			Items: this.props.model.Items,
			message: {
				type: 'success',
				body: ''
			},
		};
	},

	getModal: function (form, title, large) {
		if(!form) {
			return null;
		}

		return (
			<Modal
				closeHandler={this.cancelHandler}
				title={title}
				large={large}
			>
				{form}
			</Modal>
		);
	},

	editIntegration(integration) {
		this.setState({
			modal: this.getModal(
				<EditIntegrationForm
					cancelHandler={this.cancelHandler}
					model={this.props.model}
					integration={integration}
					afterSuccess={this.integrationChangeHandler}
				/>
			, 'Edit ' + integration.name + ' integration', false)
		});
	},

	addIntegration() {
		this.setState({
			modal: this.getModal(
				<EditIntegrationForm
					cancelHandler={this.cancelHandler}
					model={this.props.model}
					afterSuccess={this.integrationChangeHandler}
				/>
			, 'Add integration', true)
		});
	},

	integrationChangeHandler(data) {
		this.setState({
			Items: data.data.Items,
			modal: null,
			message: {
				type: 'success',
				body: data.message
			}
		});
	},

	cancelHandler: function(event) {
		if (event) {
			event.preventDefault();
		}
		this.setState({
			modal: null
		});
	},

	removeIntegration: function(requestData) {
		this.setState({
			message: {
				type: 'info',
				body: 'Loading...'
			}
		});

		// Set the security ID
		requestData.DispatcherSecurityID = this.state.SecurityID;

		$.ajax({
			url: this.props.model.RemoveURL,
			dataType: 'json',
			cache: false,
			type: 'POST',
			data: requestData,
			success: function(data) {
				this.setState({
					Items: data.data.Items,
					message: {
						type: 'success',
						body: 'Integration removed'
					}
				});
			}.bind(this),
			error: function(xhr) {
				this.setState({
					message: {
						type: 'error',
						body: this.errorMessageFromJQueryXhr(xhr),
					}
				});
			}.bind(this)
		});
	},

	errorMessageFromJQueryXhr: function(xhr) {
		let message = xhr.responseText;
		if (_.has(xhr.responseJSON, 'message')) {
			message = xhr.responseJSON.message;
		}
		if (_.has(xhr.responseJSON, 'errors')) {
			message = _.map(xhr.responseJSON.errors, function (error) {
				return error.title;
			}).join(' ');
		}
		return message;
	},

	render: function() {
		var self = this;
		var activeIntegrations = _.map(this.state.Items, function(item) {
			return (
				<IntegrationTableRow
					key={item.id}
					integration={item}
					editIntegration={self.editIntegration}
					removeIntegration={self.removeIntegration}
				/>
			);
		});

		if (this.state.Items.length === 0) {
			activeIntegrations = (
				<tr className="integration-table-row">
					<td colSpan="5" className="text-center">
						No integrations have been added yet for this environment.
					</td>
				</tr>
			);
		}

		var message = '';
		if (this.state.message.body) {
			message = (
				<div className="whitelist-message">
					<div
						className={'alert alert-' + this.state.message.type}
						dangerouslySetInnerHTML={{__html:this.state.message.body}}
					/>
				</div>
			);
		}

		return (
			<div className="table-integrations">
				<div className="row">
					<div className="col-sm-10">
						{message}
					</div>
					<div className="col-sm-2">
						<div className="actions btn-toolbar pull-right">
							<button
								type="button"
								className="btn btn-primary"
								data-step="ChooseIntegration"
								onClick={this.addIntegration}
							>
								<i className="fa fa-plus fa-fw"></i>
								Add integration
							</button>
						</div>
					</div>
				</div>

				<div className="table-responsive">
					<table className="table table-fullwidth">
						<thead>
						<tr>
							<th>Type</th>
							<th>Description</th>
							<th>Added by</th>
							<th>Created</th>
							<th width="180"></th>
						</tr>
						</thead>
						<tbody>
						{activeIntegrations}
						</tbody>
					</table>
				</div>
				{this.state.modal}
			</div>
		);
	}
});

var IntegrationTableRow = createReactClass({
	getInitialState: function() {
		return {
			status: 'ready'
		};
	},

	toggleEditIntegration: function(event) {
		if (event) {
			event.preventDefault();
		}
		if (this.state.status === 'ready') {
			this.setState({status: 'confirmation'});
		} else {
			this.setState({status: 'ready'});
		}
	},

	confirmRemoveIntegration: function(event) {
		if (event) {
			event.preventDefault();
		}
		this.setState({
			status: 'confirmation'
		});
	},

	removeIntegration: function(event) {
		if (event) {
			event.preventDefault();
		}
		this.props.removeIntegration({
			ID: this.props.integration.id,
		});

		this.toggleEditIntegration();
	},

	render: function() {
		var actions = null;
		var key = this.props.integration.id + this.state.status;

		if (this.state.status === 'confirmation') {
			actions = (
				<div key={key}>
					<button
						className="btn btn-xs btn-primary"
						title="Remove integration"
						onClick={this.removeIntegration}
					>
						Confirm
					</button>
					<button
						className="btn btn-xs btn-danger"
						onClick={this.toggleEditIntegration}
					>
						Cancel
					</button>
				</div>
			);
		} else {
			actions = (
				<div key={key}>
					<button
						onClick={() => this.props.editIntegration(this.props.integration)}
						className="btn btn-xs btn-primary"
						title="Edit Integration"
					>
						<i className="fa fa-pencil no-text"></i>
					</button>
					<button
						onClick={this.confirmRemoveIntegration}
						className="btn btn-xs btn-danger"
						title="Remove Integration"
					>
						<i className="fa fa-times no-text"></i>
					</button>
				</div>
			);
		}

		return (
			<tr className="integration-table-row">
				<td>
					<img src={this.props.integration.icon} alt={this.props.integration.name} className="integration-icon" />
					{this.props.integration.name}
				</td>
				<td>{this.props.integration.description}</td>
				<td>{this.props.integration.creator.name}</td>
				<td>{this.props.integration.created}</td>
				<td>
					{actions}
				</td>
			</tr>
		);
	}
});

module.exports = Integrations;
